// signup_data_checkout.js
import { ref } from 'vue'

// by convention, composable function names start with "use"
export function useSignupDataCheckout() {
	// state encapsulated and managed by the composable
	const signup_data_checkout = ref({
		identity: {
			id: 'none',
		},
		checkout_data_confirmation: {
			email: undefined,
			deliveryAddress: undefined,
			card: undefined,
			balance: 0
		},
		new_user: {
			email: '',
			password: '********',
			optIn: false,
			first_name: '',
			last_name: '',
			phone_number: '',
			address: {
				full_name: '',
				address_line_1: '',
				address_line_2: '',
				city: '',
				country: 'GB',
				postcode: '',
			},
			first_order_dispatch_on: undefined,
		},
	})
	function updateCheckoutData(new_data) {
		signup_data_checkout.value = { ...signup_data_checkout.value, ...new_data }
		//console.log('checkout', signup_data_checkout.value)
	}
	function updateDeliveryDate(new_data) {
		signup_data_checkout.value.new_user.first_order_dispatch_on = new_data
	}

	// expose managed state as return value
	return { signup_data_checkout, updateCheckoutData, updateDeliveryDate }
}
